//import { toggleModal } from "components/Stacker/actions/ModalActions"
import { getProductDetails } from "components/Stacker/actions/ProductDetailActions"
import {
  populateRefiners,
  //previewSelection,
  reviewSelection,
  setRearrangeStatus,
  setStackerLoadStatus,
} from "components/Stacker/actions/StackerActions"
import classNames from "classnames"
import QuickViewModal from "components/Stacker/components/QuickViewModal/QuickViewModal"
//import ModalConfig from "components/Stacker/config/ModalConfig"
import isMobile from "components/Stacker/utils/device-check"
import PropTypes from "prop-types"
import queryString from "query-string"
import { useCallback, useContext, useEffect, useRef, useState } from "react"
import { useLocation } from "react-router"
import IntroBox from "../BraceletIntroBox/BraceletIntroBox"
import BraceletItem from "../BraceletItem/BraceletItem"
import BraceletStackerHelpControls from "../BraceletStackerHelpControls/BraceletStackerHelpControls"
import BraceletShadow from "./BraceletShadow"
import "./BraceletStacker.scss"
import shadowDOM from "components/Stacker/utils/shadowDOM"
import { shallowEqual, useDispatch, useSelector } from "react-redux"
import { StackerContext } from "components/DYStackers/StackerContext"
import { useNavigate } from "react-router-dom"
import { useI18nContext } from "i18n/i18n-react"
import { gsap } from "gsap/all"
import ApiUtils from "components/Stacker/api"

const getQueryProducts = (location) => {
  const queryObj = queryString.parse(location.search, { decode: true })
  let queryProducts = []
  if (queryObj.products) {
    queryProducts = Array.isArray(queryObj.products)
      ? queryObj.products.map((product) => product.replace(/-/, " "))
      : [queryObj.products.replace(/-/, " ")]
  }
  return queryProducts
}
function BraceletStacker({ onHelpClick, onShareClick }) {
  const navigate = useNavigate()
  const location = useLocation()
  const products = useSelector((state) => state.stacker.products, shallowEqual)
  const dispatch = useDispatch()
  const { LL } = useI18nContext()
  const stackerContext = useContext(StackerContext)
  const [shouldDelay, setShouldDelay] = useState(false)
  const [selected, setSelected] = useState(getQueryProducts(location))
  const sortables = useRef([])
  const draggingItem = useRef(null)
  // const selected = useSelector(
  //   (state) => state.stacker.addedStack,
  //   shallowEqual
  // )
  // isRearrange = useSelector((state) => state.stacker.isRearrange)
  const [isRearrange, setisRearrange] = useState(false)
  const isReviewing = useSelector((state) => state.stacker.isReviewing)
  const selectedLength = useSelector((state) => state.stacker.addedStack.length)
  const initialLength = useRef(selected ? selected.length : 0)
  const [hasBraceletStarted, setHasBraceletStarted] = useState(false)
  const [hilightedItem, setHilightedItem] = useState(0)
  const [imgs, setImgs] = useState([])
  const [isHighlighted, setIsHighlighted] = useState(false)
  const stackerRef = useRef()
  const stackerContainerRef = useRef()
  const DeepRef = gsap.utils.selector(stackerContainerRef)

  const [scale, setScale] = useState(1)
  const pendingPdp = useRef([])
  const pdp = useSelector(
    (state) => state.pdp
    // (prev, next) => {
    //   const eq = shallowEqual(prev, next)
    //   if (!eq) {
    //     console.log("pdp")
    //   }
    //   for (const pid of pendingPdp.current) {
    //     if (pid in next) {
    //       if (!(pid in prev)) {
    //         return false
    //       }
    //     }
    //     if (pid in prev) {
    //       if (!(pid in next)) {
    //         return false
    //       }
    //     }
    //   }

    //   return true
    // }
  )
  const places = useRef({})
  //const [rearrangePositions, setRearrangePositions] = useState([])
  const rearrangePositions = useRef([])

  const onWindowResize = useCallback(() => {
    if (!stackerRef.current) {
      return
    }
    const scale = stackerRef.current.offsetWidth / 800
    setScale(scale > 1 ? 1 : scale)
    stackerContainerRef.current.style.transform = `scale(${scale})`
  }, [])

  useEffect(() => {
    const m = shadowDOM.getElementById("mainContentArea")
    m.classList.add("bg-white")
    m.classList.remove("bg-gray")
    dispatch(setStackerLoadStatus(true))
    window.addEventListener("resize", onWindowResize)
    onWindowResize()
    return () => {
      window.removeEventListener("resize", onWindowResize)
    }
  }, [dispatch, onWindowResize])

  useEffect(() => {
    if (initialLength.current > 0 && selectedLength === initialLength.current) {
      setShouldDelay(true)
    } else {
      setShouldDelay(false)
      initialLength.current = 0
    }
  }, [selectedLength])

  const onItemMouseOver = useCallback((id) => {
    setIsHighlighted(true)
    setHilightedItem(id)
  }, [])

  const onItemMouseOut = useCallback(() => {
    setIsHighlighted(false)
    setHilightedItem(0)
  }, [])

  const onBraceletImageLoad = useCallback(
    (id, h) => {
      const updated = imgs.filter((img) => img.id !== id)
      setImgs([...updated, { id, h }])
    },
    [imgs]
  )

  const onBraceletStart = useCallback(() => {
    setHasBraceletStarted(true)
  }, [])

  const onRearrange = useCallback(
    (updatedBracelets) => {
      const queryObj = queryString.parse(location.search, { decode: true })
      const origQueryString = queryString.stringify(queryObj, { encode: true })
      queryObj.products = updatedBracelets
      const queryParamsString = queryString.stringify(queryObj, {
        encode: true,
      })
      if (queryParamsString !== origQueryString) {
        navigate(`${location.pathname}?${queryParamsString}`)
      }
    },
    [location.pathname, location.search, navigate]
  )

  useEffect(() => {
    const newProducts = getQueryProducts(location)
    if (selected.length !== newProducts.length) {
      setSelected(newProducts)
    }
  }, [location])

  useEffect(() => {
    // Filter querystring of invalid product or variant codes
    const queryObj = queryString.parse(window.location.search, { decode: true })
    let queryProducts = []

    if (!queryObj.products) {
      // Nothing to validate
      return
    }

    queryProducts = Array.isArray(queryObj.products)
      ? queryObj.products.map((product) => product.replace(/-/, " "))
      : [queryObj.products.replace(/-/, " ")]

    let productIdStack = queryProducts
    const queryParams = {
      baseStore: pdp.queryParams.baseStore,
    }
    var queryParamsString = queryString.stringify(
      { ...queryObj, products: productIdStack },
      { encode: true }
    )
    validateNextProduct(queryProducts, queryParamsString, 0, false)
    function validateNextProduct(
      queryProducts,
      queryParamsString,
      i,
      invalidProductFound
    ) {
      var item = queryProducts[i]
      const url = `v1/retailer/${stackerContext.retailerId}/product/${item}`
      ApiUtils.makeAjaxRequest(
        {
          url: url,
          queryParams,
        },
        (res) => {
          // Empty result => product not found
          if (!res) {
            invalidProductFound = true
            productIdStack = queryProducts.filter((p) => {
              return p != item
            })
            queryParamsString = queryString.stringify(
              { ...queryObj, products: productIdStack },
              { encode: true }
            )
            console.log("Product not found " + item)
          }

          if (i + 1 == queryProducts.length) {
            if (invalidProductFound) {
              navigate(`${location.pathname}?${queryParamsString}`)
              window.location.reload() // Force refresh the state of the stacker
            }
          } else {
            validateNextProduct(
              queryProducts,
              queryParamsString,
              i + 1,
              invalidProductFound
            )
          }
        },
        (err) => {
          console.log("Failed to fetch product for validation " + err)
        }
      )
    }
  }, [location])

  const setSortables = (items) => {
    const newSortables = []
    // remove not selected
    for (let i = 0; i < items.length; i++) {
      const exists = sortables.current.findIndex(
        (item) => item.item === items[i]
      )
      if (exists >= 0) {
        newSortables.push({ ...sortables.current[i], index: i })
      } else {
        newSortables.push({
          index: i,
          item: items[i],
          pos: 0,
        })
      }
    }
    sortables.current = newSortables
  }

  useEffect(() => {
    setSortables(selected)
  }, [selected])

  const onDrag = useCallback(
    (id, yPos) => {
      // const tempBracelets = [...selected]
      // const positions = rearrangePositions.current
      // const startIndex = selected.indexOf(id)
      // let position = 0
      // let removedBracelets = []

      onItemMouseOver(id)
      draggingItem.current = id

      let sort = false
      const itemIndex = sortables.current.findIndex((item) => item.item === id)
      if (itemIndex >= 1 && sortables.current[itemIndex - 1].pos < yPos) {
        const currentPos = sortables.current[itemIndex].pos
        sortables.current[itemIndex].pos = sortables.current[itemIndex - 1].pos
        sortables.current[itemIndex].index = itemIndex - 1
        sortables.current[itemIndex - 1].pos = currentPos
        sortables.current[itemIndex - 1].index = itemIndex
        sort = true
        gsap.to(
          DeepRef(
            "#" + sortables.current[itemIndex - 1].item.replace(/ /, "-")
          )[0],
          {
            y: currentPos,
            duration: 0.3,
          }
        )
        console.log(
          "Sending " +
            sortables.current[itemIndex - 1].item +
            " to " +
            currentPos
        )
      } else {
        if (
          itemIndex < sortables.current.length - 1 &&
          sortables.current[itemIndex + 1].pos > yPos
        ) {
          const currentPos = sortables.current[itemIndex].pos
          sortables.current[itemIndex].pos =
            sortables.current[itemIndex + 1].pos
          sortables.current[itemIndex].index = itemIndex + 1
          sortables.current[itemIndex + 1].pos = currentPos
          sortables.current[itemIndex + 1].index = itemIndex
          sort = true
          gsap.to(
            DeepRef(
              "#" + sortables.current[itemIndex + 1].item.replace(/ /, "-")
            )[0],
            {
              y: currentPos,
              duration: 0.3,
            }
          )
          console.log(
            "Sending " +
              sortables.current[itemIndex + 1].item +
              " to " +
              currentPos
          )
        }
      }
      if (sort) {
        sortables.current.sort((a, b) => b.pos - a.pos)
      }
      return sortables.current[itemIndex].pos
      // positions.forEach((pos, i) => {
      //   const x = i
      //   if (
      //     x !== startIndex &&
      //     ((yPos > pos && x < startIndex) || (yPos < pos && x > startIndex))
      //   ) {
      //     removedBracelets = tempBracelets.splice(startIndex, 1)
      //     position = x
      //     tempBracelets.splice(position, 0, ...removedBracelets)
      //   }
      // })
      //onRearrange(tempBracelets)
    },
    [DeepRef, onItemMouseOver]
  )

  const onDragEnd = useCallback(() => {
    onItemMouseOut()
    draggingItem.current = null
    const newProducts = sortables.current.map((item) => item.item)
    onRearrange(newProducts)
  }, [onItemMouseOut])

  const onAddMoreClick = useCallback((e) => {
    e.preventDefault()
    //dispatch(previewSelection(false))
  }, [])

  const onRearrangeClick = useCallback(() => {
    //dispatch(setRearrangeStatus(!isRearrange))
    //sortables.current.sort((a, b) => b.pos - a.pos)
    // if(isRearrange){
    //   rea
    // }
    setisRearrange((value) => !value)
  }, [])

  useEffect(() => {
    dispatch(setRearrangeStatus(isRearrange))
  }, [dispatch, isRearrange])

  const setPositions = (pos, i) => {
    const updatedPositions = [...rearrangePositions.current]
    updatedPositions[i] = pos
    rearrangePositions.current = updatedPositions
    sortables.current[i].pos = pos
    // setRearrangePositions((positions) => {
    //   positions[i] = pos
    //   return positions
    // })
  }

  const onReviewClick = useCallback(
    (e) => {
      e.preventDefault()
      dispatch(
        populateRefiners({
          data: selected,
        })
      )
      dispatch(reviewSelection(true))
    },
    [dispatch]
  )

  const onUnmount = useCallback((id) => {
    setImgs((images) => images.filter((img) => img.id !== id))
  }, [])

  useEffect(() => {
    selected.forEach((item) => {
      const itemPdp = pdp[item]
      if (!itemPdp && !pendingPdp.current.includes(item)) {
        dispatch(
          getProductDetails({
            args: { productId: item },
            retailerId: stackerContext.retailerId,
          })
        )
        pendingPdp.current.push(item)
      }
      const baseId = item.substr(0, 9)
      const basePdp = pdp[baseId]
      if (!basePdp && !pendingPdp.current.includes(baseId)) {
        dispatch(
          getProductDetails({
            args: { productId: baseId },
            retailerId: stackerContext.retailerId,
          })
        )
        pendingPdp.current.push(baseId)
      }
    })
    // reason: pdp only needs to be checked when selected is changed
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected, dispatch, stackerContext.retailerId])

  const braceletSpacing = {
    normal: 100,
    rearrange: 0,
  }

  const getHeightById = (id) => {
    const imgRow = imgs.filter((img) => img.id === id)
    return imgRow.length === 0 ? 0 : imgRow[0].h
  }
  const getItemsHeight = () => {
    const spacing = !isRearrange
      ? braceletSpacing.normal
      : braceletSpacing.rearrange
    let height = 0
    imgs.forEach((img) => {
      height += img.h - spacing
    })

    return height
  }

  let lastZIndex = 100
  const getItems = () => {
    if (selected.length === 0) {
      return null
    }
    if (selected.length !== sortables.current.length) {
      setSortables(selected)
    }
    let acc = 0
    let to = 0
    let delay = 0
    const spacing = !isRearrange
      ? braceletSpacing.normal
      : braceletSpacing.rearrange
    const stackerHeight = getItemsHeight()
    rearrangePositions.current = []
    const items = sortables.current.map((sortable, i) => {
      const item = sortable.item
      const baseId = item.substr(0, 9)
      if (imgs.length === selected.length) {
        if (imgs.length === 1) {
          acc = stackerHeight - imgs[0].h
        } else {
          const currHeight = getHeightById(item)
          const prevHeight = getHeightById(selected[i - 1])
          acc +=
            i === 0
              ? stackerHeight - imgs[0].h + spacing - 50
              : -(prevHeight + currHeight - prevHeight) + spacing
        }

        to =
          stackerHeight * scale + 100 * scale >
          stackerRef.current.offsetHeight - 125 * scale
            ? acc + 50 + 120
            : stackerRef.current.offsetHeight / 2 - stackerHeight / 2 + acc
      }

      if (to > 0) {
        setPositions(to, i)
        console.log(`set ${i} to ${to} and isRearrange is ${isRearrange}`)
      }

      let inFocus = "neutral"
      if (isRearrange) {
        if (isHighlighted && hilightedItem === item) {
          inFocus = "yes"
        } else if (isHighlighted && hilightedItem !== item) {
          inFocus = "no"
        }
      }

      const pdpItem = pdp[baseId]
      if (!pdpItem || !pdpItem.data) {
        return null
      }

      const autoStart = stackerHeight > 0 && imgs.length === selected.length
      const variants = pdpItem.data.products.variantOptions
      const selectedVariant = variants.filter(
        (variant) => variant.code === item
      )[0]

      if (!selectedVariant) {
        return null
      }
      const src = `${selectedVariant.imageURL}_STACK_NOSHADOW.png`

      const key = item.replace(/ /, "-")

      let newZIndex = -1 * to - 1
      if (lastZIndex > newZIndex) {
        lastZIndex = newZIndex
      }

      const braceletItem = (
        <BraceletItem
          autoStart={autoStart}
          baseProduct={pdpItem}
          //dispatch={dispatch}
          delay={delay}
          duration={1} //was {resize ? 0 : 1} but resize is never set nor used
          index={i}
          id={item}
          inFocus={inFocus}
          isRearrange={isRearrange}
          key={key}
          product={selectedVariant}
          src={src}
          to={to || 0.5}
          onBraceletStart={onBraceletStart}
          onDrag={onDrag}
          onDragEnd={onDragEnd}
          onItemMouseOver={onItemMouseOver}
          onItemMouseOut={onItemMouseOut}
          onLoad={onBraceletImageLoad}
          onUnmount={onUnmount}
          //navigate={navigate}
          //location={location}
        />
      )
      if (shouldDelay) delay += 0.075
      return braceletItem
    })

    return items
  }

  const list = getItems()

  const hasProducts = selected.length > 0
  const stackerHeight = getItemsHeight()
  // const shouldScroll = true;
  const shouldScroll = stackerRef.current
    ? stackerHeight * scale + 100 * scale >
      stackerRef.current.offsetHeight - 125 * scale
    : false
  const stackerClasses = classNames("mx-auto", {
    "overflow-scroll": true,
    rearrange: isRearrange,
  })
  const containerStyles = { transformOrigin: "top" }
  const shadowOpacity = hasBraceletStarted && hasProducts ? 0.4 : 0
  // const shadowTop = stackerRef.current ? stackerHeight : -200;
  let shadowTop = window.innerWidth > 767 ? 400 : 220
  if (stackerRef.current) {
    shadowTop = shouldScroll
      ? stackerHeight + 220
      : stackerRef.current.offsetHeight / 2 -
        stackerHeight / 2 +
        stackerHeight +
        (imgs.length === 1 ? 0 : 50)
  }

  const mensStyle = {
    background:
      "linear-gradient(146.95deg, var(--dy-background-primary-color, rgb(7,7,7)) 20%, var(--dy-background-primary-color, rgb(69,69,69)) 97.25%)",
  }
  const womensStyle = {
    background:
      "linear-gradient(146.95deg, var(--dy-background-primary-color, #FBFBFB) 19.71%, var(--dy-background-primary-color, #D7D7D7) 97.25%)",
  }
  const stackerStyle = stackerContext.gender == "men" ? mensStyle : womensStyle

  return (
    <div
      className="stacker d-flex align-items-center h-100 w-100 "
      style={stackerStyle}
    >
      {!hasProducts && <IntroBox />}
      <div id="stacker-bracelet" className={stackerClasses} ref={stackerRef}>
        <div
          id="stacker-bracelet-container"
          className="position-relative h-100"
          ref={stackerContainerRef}
          style={{
            ...(shouldScroll ? containerStyles : null),
          }}
        >
          {list}
          <BraceletShadow
            duration={1}
            opacity={shadowOpacity}
            scale={scale}
            to={shadowTop}
            zIndex={lastZIndex}
          />
        </div>
      </div>
      <BraceletStackerHelpControls
        onHelpClick={onHelpClick}
        onShareClick={onShareClick}
      />
      <QuickViewModal dispatch={dispatch} />
      {selected.length > 0 && !isReviewing && (
        <div className="stacker-controls w-100">
          <button
            className="btn btn-rearrange btn-std"
            onClick={onRearrangeClick}
          >
            {!isRearrange ? LL.bracelets.rearrange() : LL.bracelets.done()}
          </button>
        </div>
      )}
    </div>
  )
}

BraceletStacker.propTypes = {
  onHelpClick: PropTypes.func.isRequired,
  onShareClick: PropTypes.func.isRequired,
}

export default BraceletStacker
